import { createContext, Dispatch, SetStateAction, useContext } from "react";

import { Sentiment } from "@/constants";
import { TimeCluster } from "@/containers/MentionCard/utils/clusterTimes";
import { AudioMentionV4, MentionCard, MentionV4 } from "@/types/MentionCard";

export type MentionCardContextType = {
  hideActions?: boolean;
  hideSimilar?: boolean;
  hideMetadata?: boolean;
  hideReach?: boolean;
  hideSentiment?: boolean;
  hidePrValue?: boolean;
  hideTags?: boolean;
  searchIsProcessing?: boolean;
  clusters: TimeCluster[];
  is_paywalled?: boolean;
  is_report?: boolean;
  can_mark_favorite?: boolean;
  visibleMentions?: number;
  show?: string;
  removeAll: () => void;
  removeSource: () => void;
  removeIndividual: (id: string) => void;
  removedMentionIds: string[];
  removedSource: boolean;
  undoRemoveMention: (id: string[], unhide_source?: boolean) => void;
  updateMentionSentiment: (public_id: MentionV4, sentiment: Sentiment) => void;
  updateAggregatedSentiment: (sentiment: Sentiment) => void;
  sentimentActive: boolean;
  setSentimentActive: Dispatch<SetStateAction<boolean>>;

  // split of the mentions
  audioMentions: AudioMentionV4[];
  textMentions: MentionV4[];
  episodeNameMentions: MentionV4[];
  episodeDescriptionMentions: MentionV4[];
  channelTitleMentions: MentionV4[];

  // modal
  mediaModalOpen: boolean;
  setMediaModalOpen: Dispatch<SetStateAction<boolean>>;
  readerModalOpen: boolean;
  setReaderModalOpen: Dispatch<SetStateAction<boolean>>;
  // Translation methods
  translateMention: (
    mention: MentionV4,
    fromKey?: keyof MentionV4,
    toKey?: keyof MentionV4
  ) => void;
  unTranslateMention: (mention: MentionV4, toKey?: keyof MentionV4) => void;
} & MentionCard;

const MentionCardContext = createContext<MentionCardContextType>(
  {} as MentionCardContextType
);

export const useMentionCard = () => useContext(MentionCardContext);

export default MentionCardContext;
